import { authFetch, buildAuthHeaders } from "../../../public/api/httpClient";
import { VISITOR_API_ROUTES } from "../utils/visitorApiRoutes";
import { authJsonHeaders, buildApiError, parseJson } from "./apiHelpers";

const BASE = VISITOR_API_ROUTES.visitors;

export async function getVisitors({ scope = "self" } = {}) {
  const qs = scope ? `?scope=${encodeURIComponent(scope)}` : "";
  const res = await authFetch(`${BASE}${qs}`, {
    credentials: "include",
    headers: buildAuthHeaders(),
  });
  const data = await parseJson(res);
  if (!res.ok) throw buildApiError(res, data, "Failed to fetch visitors");
  return data;
}

export async function getVisitorById(id) {
  const res = await authFetch(`${BASE}/${encodeURIComponent(String(id))}`, {
    credentials: "include",
    headers: buildAuthHeaders(),
  });
  const data = await parseJson(res);
  if (!res.ok) throw buildApiError(res, data, "Failed to fetch visitor");
  return data;
}

export async function getVisitorSlip(id) {
  const res = await authFetch(
    `${BASE}/${encodeURIComponent(String(id))}/slip`,
    {
      credentials: "include",
      headers: buildAuthHeaders(),
    },
  );
  const data = await parseJson(res);
  if (!res.ok) throw buildApiError(res, data, "Failed to fetch visitor slip");
  return data;
}

export async function createVisitor(body, csrfToken) {
  const res = await authFetch(BASE, {
    method: "POST",
    credentials: "include",
    headers: buildAuthHeaders(authJsonHeaders(csrfToken)),
    body: JSON.stringify(body),
  });
  const data = await parseJson(res);
  if (!res.ok) throw buildApiError(res, data, "Failed to create visitor");
  return data;
}

export async function updateVisitor(id, body, csrfToken) {
  const res = await authFetch(`${BASE}/${encodeURIComponent(String(id))}`, {
    method: "PUT",
    credentials: "include",
    headers: buildAuthHeaders(authJsonHeaders(csrfToken)),
    body: JSON.stringify(body),
  });
  const data = await parseJson(res);
  if (!res.ok) throw buildApiError(res, data, "Failed to update visitor");
  return data;
}

export async function markVisitorExit(id, body, csrfToken) {
  const res = await authFetch(
    `${BASE}/${encodeURIComponent(String(id))}/exit`,
    {
      method: "PATCH",
      credentials: "include",
      headers: buildAuthHeaders(authJsonHeaders(csrfToken)),
      body: JSON.stringify(body ?? {}),
    },
  );
  const data = await parseJson(res);
  if (!res.ok) throw buildApiError(res, data, "Failed to mark visitor exit");
  return data;
}

export async function deleteVisitor(id, csrfToken) {
  const res = await authFetch(`${BASE}/${encodeURIComponent(String(id))}`, {
    method: "DELETE",
    credentials: "include",
    headers: buildAuthHeaders(authJsonHeaders(csrfToken)),
  });
  const data = await parseJson(res);
  if (!res.ok) throw buildApiError(res, data, "Failed to delete visitor");
  return data;
}

export function normalizeStaffSearchResponse(payload) {
  if (Array.isArray(payload)) return { data: payload };
  if (Array.isArray(payload?.data)) return { data: payload.data };
  return { data: [] };
}

export async function searchStaffUsers(query) {
  const params = new URLSearchParams();
  if (query) params.append("q", String(query).trim());
  const res = await authFetch(
    `${VISITOR_API_ROUTES.staffSearch}?${params.toString()}`,
    {
      credentials: "include",
      headers: buildAuthHeaders(),
    },
  );
  const data = await parseJson(res);
  if (!res.ok) throw buildApiError(res, data, "Error searching staff");
  return normalizeStaffSearchResponse(data);
}
